import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer py-5">
      <Container>
        <Row className="mb-4">
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5 className="text-white mb-3">비나이다</h5>
            <p className="text-white-50 mb-4">
              함께 기도하며 나아가는 커뮤니티입니다. 
              여러분의 기도와 나눔이 세상을 변화시킵니다.
            </p>
            <div className="d-flex social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="me-3">
                <FaFacebook size={22} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="me-3">
                <FaInstagram size={22} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="me-3">
                <FaTwitter size={22} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FaYoutube size={22} />
              </a>
            </div>
          </Col>
          
          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="text-white mb-3">바로가기</h6>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/about">소개</Link>
              </li>
              <li className="mb-2">
                <Link to="/pray">기도</Link>
              </li>
              <li className="mb-2">
                <Link to="/notice">공지사항</Link>
              </li>
              <li>
                <Link to="/qna">Q&A</Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <h6 className="text-white mb-3">정보</h6>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/privacy-policy">개인정보처리방침</Link>
              </li>
              <li className="mb-2">
                <Link to="/terms-of-service">이용약관</Link>
              </li>
              <li>
                <Link to="/contact">문의하기</Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={3} md={6}>
            <h6 className="text-white mb-3">연락처</h6>
            <p className="text-white-50 mb-1">상호: (주)비나이다컴퍼니</p>
            <p className="text-white-50 mb-1">대표: 원성준</p>
            <p className="text-white-50 mb-1">전화: 02-2680-1080</p>
            <p className="text-white-50 mb-1">사업자 등록번호: 194-86-02267</p>
            <p className="text-white-50">주소: 서울특별시 금천구 가산디지털1로 142, 913-3호</p>
          </Col>
        </Row>
        
        <div className="text-center pt-4 mt-4 border-top border-secondary">
          <p className="text-white-50 mb-0">&copy; {new Date().getFullYear()} 비나이다. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;